/** Viewport width below which Glass uses mobile layout / collapsible behavior. */
export const GLASS_MOBILE_BREAKPOINT = 960;

export type GlassCollapseInput = {
    width: number;
    isCaf: boolean;
    /** Glass options test arm (ab-glass-options.ts): the panel starts open everywhere so the boxes and photo show without a tap; it stays collapsible where it is today. */
    startExpanded?: boolean;
};

export type GlassCollapseState = {
    isMobile: boolean;
    /** Mobile and CAF sections collapse; non-CAF desktop stays open and non-collapsible. */
    canCollapse: boolean;
    /** Expanded value to apply when `canCollapse` changes (always open when not collapsible, or when `startExpanded` is set). */
    defaultExpanded: boolean;
};

export type GlassInfoIconPosition = {
    position: 'absolute';
    top: number;
    left?: number;
    right?: number;
};

export function getGlassCollapseState({width, isCaf, startExpanded}: GlassCollapseInput): GlassCollapseState {
    const isMobile = width < GLASS_MOBILE_BREAKPOINT;
    const canCollapse = Boolean(isCaf || isMobile);
    return {
        isMobile,
        canCollapse,
        defaultExpanded: !canCollapse || Boolean(startExpanded),
    };
}

/** Panel class driven by the authoritative expanded flag. */
export function getGlassInnerClassName(canCollapse: boolean, expanded: boolean): string {
    if (!canCollapse) return '';
    return expanded ? 'collapse show' : 'collapse';
}

/**
 * Info-icon overlay position. Sets only one horizontal edge so the wrapper never
 * stretches across the disclosure header (CAF + mobile previously set both).
 */
export function getGlassInfoIconPosition({width, isCaf}: GlassCollapseInput): GlassInfoIconPosition {
    const {isMobile} = getGlassCollapseState({width, isCaf});
    if (isMobile) {
        return {position: 'absolute', top: 6, left: 55};
    }
    return {position: 'absolute', top: isCaf ? 10 : 5, right: isCaf ? 40 : 8};
}
